(function initLeadFaq() {
  function bindFaqList(list) {
    const items = Array.from(list.querySelectorAll('.vestfirma-lead-faq__item'));

    items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (!(summary instanceof HTMLElement) || summary.dataset.faqBound === 'true') return;

      summary.dataset.faqBound = 'true';
      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        const opening = !item.open;

        items.forEach((other) => {
          if (other !== item) {
            other.open = false;
            const otherSummary = other.querySelector('summary');
            otherSummary?.setAttribute('aria-expanded', 'false');
          }
        });

        item.open = opening;
        summary.setAttribute('aria-expanded', opening ? 'true' : 'false');

        const active = document.activeElement;
        if (active instanceof HTMLElement && active.closest('vestfirma-lead-form')) {
          active.blur();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.vestfirma-lead-faq__list').forEach(bindFaqList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
